import React from 'react'

import { ZariContext } from '_zari/context'

import { TreeView, Portlet, Button, Col, Row } from '_zari/core'

import * as EsquemaBalanceGeneralService from 'services/esquemaBalanceGeneral.service'

import * as Modals from './modals'

// import './index.scss'

const portletBreadcrumbs = [{ name: 'Estados Financieros' }, { name: 'Balance General' }, { name: 'Esquema' }]

const EsquemaBalanceGeneralTreeView = () => {
  const __zariContext = React.useContext(ZariContext)

  const [itemsEsquema, setItemsEsquema] = React.useState([])

  const [agregarButtonDisabled, setAgregarButtonDisabled] = React.useState(false)
  const [editarButtonDisabled, setEditarButtonDisabled] = React.useState(false)
  const [eliminarButtonDisabled, setEliminarButtonDisabled] = React.useState(false)

  const [mostrarInsertarActualizarModal, setMostrarInsertarActualizarModal] = React.useState(false)

  const nodoPadreDataRef = React.useRef({})
  const editarDataRef = React.useRef({})

  const selectedId = React.useRef(null)

  const reloadTree = React.useCallback(() => {
    EsquemaBalanceGeneralService.obtenerAsTreeView().then(({ data }) => {
      setItemsEsquema(data)
      setAgregarButtonDisabled(false)
      setEditarButtonDisabled(false)
      setEliminarButtonDisabled(false)
    })
  }, [])

  const obtenerItemxId = React.useCallback(
    id => {
      const nodeInfo = itemsEsquema.find(x => x._id === id)
      return nodeInfo
    },
    [itemsEsquema]
  )

  const onSelectNode = React.useCallback(id => {
    selectedId.current = id
  }, [])

  const clickAgregarHandler = React.useCallback(() => {
    nodoPadreDataRef.current = {}
    editarDataRef.current = {}

    if (selectedId.current) {
      const itemInfo = obtenerItemxId(selectedId.current)
      if (itemInfo) {
        nodoPadreDataRef.current = itemInfo
      }
    }

    setMostrarInsertarActualizarModal(true)
  }, [obtenerItemxId])

  const clickEditarHandler = React.useCallback(() => {
    const nodoInfo = obtenerItemxId(selectedId.current)
    nodoPadreDataRef.current = {}
    if (nodoInfo.nivel !== 1) {
      const nodoPadreInfo = obtenerItemxId(nodoInfo._parentId)
      nodoPadreDataRef.current = nodoPadreInfo
    }

    EsquemaBalanceGeneralService.obtenerxIdAsEdicion(selectedId.current)
      .then(({ data }) => {
        editarDataRef.current = {
          ...nodoInfo,
          ...data
        }

        setMostrarInsertarActualizarModal(true)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, obtenerItemxId])

  const clickEliminarItemHandler = React.useCallback(() => {
    EsquemaBalanceGeneralService.eliminarxId(selectedId.current)
      .then(() => {
        reloadTree()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, reloadTree])

  React.useEffect(() => {
    reloadTree()
  }, [reloadTree])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Estados Financieros' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body className='cuentas_contables_arbol'>
          <Row className='row_buttons_wrapper'>
            <Col xs={12} sm={12} className='col_crud_buttons_wrapper'>
              <Button onClick={clickAgregarHandler} disabled={agregarButtonDisabled}>
                Agregar
              </Button>
              <Button onClick={clickEditarHandler} disabled={editarButtonDisabled}>
                Editar
              </Button>
              <Button onClick={clickEliminarItemHandler} disabled={eliminarButtonDisabled}>
                Eliminar
              </Button>
            </Col>
          </Row>
          <div className='treeview_wrapper'>
            <TreeView items={itemsEsquema} onSelect={onSelectNode} />
          </div>
        </Portlet.Body>
      </Portlet>
      {mostrarInsertarActualizarModal && (
        <Modals.InsertarActualizarModal
          nodoPadreData={nodoPadreDataRef.current}
          editarData={editarDataRef.current}
          handleClose={e => setMostrarInsertarActualizarModal(false)}
          show={mostrarInsertarActualizarModal}
          reloadTree={reloadTree}
        />
      )}
    </>
  )
}

export default React.memo(EsquemaBalanceGeneralTreeView)
